import { Model } from '@vuex-orm/core';

export default class Setting extends Model {
  static entity = 'settings';

  static state () {
    return {
      colors: {
        loader: 'inherit',
      }
    }
  }

  static fields() {
    return {
      id: this.uid(null),
      name: this.attr(null),
      value: this.attr(null),
      type: this.attr(null),
    }
  }
}